import { render, staticRenderFns } from "./PrintAreaIcons.vue?vue&type=template&id=3f3ab243"
import script from "./PrintAreaIcons.vue?vue&type=script&lang=js"
export * from "./PrintAreaIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports